export default __webpack_public_path__ + "static/media/ss.7796f4a4.png";